export const downloadImage = async (url: string, name?: string) => {
  const response = await fetch(url)
  const blob = await response.blob()
  const urlBlob = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = urlBlob
  a.download = name ?? ''
  a.click()
  URL.revokeObjectURL(urlBlob)
}
